/** @format */

import { Navigate } from "react-router-dom";
import { getCookie } from "../utils/commonfunction.js";
import { lazyLoad } from "../utils/lazyLoad";
import { routesName } from "./routesName.js";

const ProtectedRoute = lazyLoad(
  () => import("../components/protected/ProtectedRoute.js"),
); // Correct dynamic import
const AdminWidget = lazyLoad(() => import("../pages/Admin/Widget/Widget.js")); // Correct dynamic import
const ErrorElement = lazyLoad(() => import("../components/ErrorElement.js")); // Correct dynamic import
const Widget = lazyLoad(() => import("../pages/Widget/Widget.js")); // Correct dynamic import
const Home = lazyLoad(() => import("../pages/Home")); // Correct dynamic import
const Provider = lazyLoad(() => import("../pages/Provider"));
// Renders PersonalDetailsform, or the reschedule confirm step in reschedule mode.
const PersonalDetailsform = lazyLoad(
  () => import("../pages/Reschedule/AdditionalDetailsSwitch.js"),
);
const InsurancePolicy = lazyLoad(() => import("../pages/InsurancePolicy"));

const Identity = lazyLoad(() => import("../pages/Identity/Identity.js"));

const SuccessScreen = lazyLoad(
  () => import("../pages/SuccessScreen/SuccessScreen.js"),
);

const VirtualCheckIn = lazyLoad(() => import("../pages/VirtualCheckIn"));

const MainLayout = lazyLoad(() => import("../pages/MainLayout.js"));
const Login = lazyLoad(() => import("../pages/Admin/NewLogin/NewLogin.js"));
const NotFound = lazyLoad(() => import("../components/common/NotFound.js"));

const AdminLayout = lazyLoad(
  () => import("../components/common/AdminLayout.js"),
);
const ManageSchedular = lazyLoad(
  () => import("../pages/Admin/ManageSchedular/ManageSchedular.js"),
);
const AllSchedularList = lazyLoad(
  () =>
    import("../pages/Admin/ManageSchedular/AllSchedulersList/AllSchedulersList.js"),
);
const CreateLink = lazyLoad(() => import("../pages/Admin/createLink/index.js"));
const ProviderControl = lazyLoad(
  () => import("../pages/Admin/providercontrol/index.js"),
);
const EditProfile = lazyLoad(
  () => import("../pages/Admin/editprovider/index.js"),
);
const JoinWaitlistTable = lazyLoad(
  () => import("../pages/Admin/JoinWaitlist/index.js"),
);
const ConfigureServices = lazyLoad(
  () => import("../pages/Admin/servicescontrol/index.js"),
);
const LocationsConfig = lazyLoad(
  () => import("../pages/Admin/locationService/index.js"),
);

const InsurancesConfig = lazyLoad(
  () => import("../pages/Admin/Insurancecontrol/index.js"),
);
const Patients = lazyLoad(() => import("../pages/Admin/Patients/index.js"));
const PatientDetails = lazyLoad(
  () => import("../pages/Admin/Patients/patientsDetails/patientDetails.js"),
);
const Reports = lazyLoad(() => import("../pages/Admin/Reports/Reports.js"));

const Analytics = lazyLoad(() => import("../pages/Analytics/Analytics.js"));

const InitialPage = () => (
  <Navigate to={`/${routesName.ADMIN_LOGIN}`} replace />
);
const LoadingPage = lazyLoad(() => import("../pages/InitialPage/index.js"));
const Blank = lazyLoad(() => import("../pages/Admin/Blank/Blank.js")); // Correct dynamic import
const IntakeQuestion = lazyLoad(() => import("../pages/IntakeQuestion"));

const WrapperProtected = (Com, isProtected = false) => {
  return isProtected ? (
    <ProtectedRoute>
      <Com />
    </ProtectedRoute>
  ) : (
    <Com />
  );
};

const ProtectWidget = (Com) => {
  const isInIframe = window.self !== window.top;
  return isInIframe || true ? <Com /> : <Navigate to="/404" replace />;
};

const routes = [
  {
    path: "*",
    isProtected: false,
    element: WrapperProtected(NotFound),
  },
  {
    path: "/",
    isProtected: false,
    errorElement: <ErrorElement />,
    element: getCookie("ssoToken")
      ? WrapperProtected(LoadingPage)
      : WrapperProtected(InitialPage),
  },
  {
    path: `/${routesName.ADMIN_LOGIN}`,
    isProtected: false,
    element: WrapperProtected(Login),
  },
  {
    path: `/:clientName/:scheduler/:location/`,
    element: WrapperProtected(MainLayout),
    errorElement: <ErrorElement />,

    children: [
      {
        path: routesName.LANDING,
        element: WrapperProtected(Home),
      },
      {
        path: routesName.FIND_APPOINTMENT,
        element: WrapperProtected(Provider, true),
      },

      {
        path: routesName.ADDITIONAL_DETAILS,
        element: WrapperProtected(PersonalDetailsform, true),
      },
      {
        path: routesName.INTAKE_QUESTION,
        element: WrapperProtected(IntakeQuestion, true),
      },
      {
        path: routesName.INSURANCE,
        element: WrapperProtected(InsurancePolicy, true),
      },
      {
        path: routesName.IDENTITY,
        element: WrapperProtected(Identity, true),
      },

      {
        path: routesName.THANKYOU,
        element: WrapperProtected(SuccessScreen, true),
      },
      {
        path: `${routesName.VIRTUAL_CHECKIN}/:appointmentId`,
        element: WrapperProtected(VirtualCheckIn, true),
      },
      {
        path: routesName.WIDGET,
        element: ProtectWidget(Widget),
      },
    ],
  },
  {
    path: "/admin/:ClientId/:ruleId",
    element: WrapperProtected(AdminLayout, true),
    errorElement: <ErrorElement />,

    children: [
      {
        path: routesName.ADMIN_MANAGE_SCHEDULER,
        element: WrapperProtected(ManageSchedular, true),
      },
      {
        path: routesName.ADMIN_CREATE_LINK,
        element: WrapperProtected(CreateLink, true),
      },
      {
        path: routesName.ADMIN_PROVIDER_CONTROL,
        element: WrapperProtected(ProviderControl, true),
      },
      {
        path: `${routesName.ADMIN_PROVIDER_EDIT_CONTROL}/:providerid`,
        element: WrapperProtected(EditProfile, true),
      },
      {
        path: routesName.ADMIN_WAIT_LIST,
        element: WrapperProtected(JoinWaitlistTable, true),
      },
      {
        path: routesName.ADMIN_SERVICE_CONTROL,
        element: WrapperProtected(ConfigureServices, true),
      },
      {
        path: routesName.ADMIN_INSURANCE_CONTROL,
        element: WrapperProtected(InsurancesConfig, true),
      },
      {
        path: routesName.ADMIN_LOCATION_CONTROL,
        element: WrapperProtected(LocationsConfig, true),
      },
      {
        path: routesName.ADMIN_REPORTS,
        element: WrapperProtected(Reports, true),
      },
      {
        path: routesName.ADMIN_WIDGET,
        element: WrapperProtected(AdminWidget, true),
      },
      {
        path: routesName.ADMIN_ANALYTICS,
        element: WrapperProtected(Analytics, true),
      },
      {
        path: routesName.ADMIN_BLANK,
        element: WrapperProtected(Blank, true),
      },
      {
        path: routesName.ADMIN_PATIENTS,
        element: WrapperProtected(Patients, true),
      },
      {
        path: `${routesName.ADMIN_PATIENT_DETAILS}/:patientId/:appointmentId`,
        element: WrapperProtected(PatientDetails, true),
      },
      {
        path: routesName.ADMIN_ALL_SCHEDULERS_LIST,
        element: WrapperProtected(AllSchedularList, true),
      },
    ],
  },
];

export default routes;
